export default __webpack_public_path__ + "static/media/xxx.e3ed35e7.svg";